<template>
  <div class="content">
    <div class="stem-content" :class="{ 'no-border': !border }">
      <div v-if="!content && !fileInfo.fileUrl" class="placeholder">
        {{ placeholder }}
      </div>
      <div v-else-if="content">
        <div class="text-break-all" v-html="formatImg(content)"></div>
        <slot></slot>
      </div>
      <bc-file-render
        :playbackControl="playbackControl"
        :isLineFile="isLineFile"
        @play="$emit('play')"
        :mobile="mobile"
        :style="{ 'margin-top': content ? '16px' : 0, padding: '10px 0' }"
        v-if="fileInfo.fileUrl"
        :showHandler="false"
        :fileInfo="fileInfo"
      ></bc-file-render>
    </div>
  </div>
</template>

<script>
export default {
  name: "bc-view-common",
  props: {
    content: {
      type: String,
      default: "",
    },
    fileInfo: {
      type: Object,
      default: () => ({
        fileUrl: "",
        fileType: "",
        fileSuffix: "",
      }),
    },
    placeholder: {
      type: String,
      default: "",
    },
    border: {
      type: Boolean,
      default: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    isLineFile: {
      type: Boolean,
      default: false,
    },
    playbackControl: {
      type: String,
      default: "0",
    },
  },
  methods: {
    formatImg(str) {
      let data = str.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
        (match, p1) => {
          return `<img src='${p1}' style="display: block;max-width: 100%; height: auto" />`;
        }
      );
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  .stem-content {
    width: 100%;
    box-sizing: border-box;
    padding: 5px 14px;
    height: auto;
    border: 1px solid #e7e7e7;
    border-radius: 6px;
    cursor: pointer;

    &.no-border {
      padding: 0;
      border: none;
      cursor: default;
    }
    .placeholder {
      color: #c0c4cc;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
    }
  }
}
.text-break-all_row {
  display: flex;
  flex-direction: row;
}
</style>
